import { useCallback, useState } from 'react'
import { useDebounce } from 'react-use'

export function useRequestsTableFilters(initialPageSize = 5) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: initialPageSize,
  })
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [selectedFilter, setSelectedFilter] = useState<string | undefined>(undefined)

  const handleFilterChange = useCallback((value: string | undefined) => {
    setSelectedFilter(value)
    setPaginationModel(prev => ({ ...prev, page: 0 }))
  }, [])

  useDebounce(
    () => {
      setDebouncedSearchQuery(searchQuery)
      setPaginationModel(prev => ({ ...prev, page: 0 }))
    },
    300,
    [searchQuery],
  )

  return {
    searchQuery,
    debouncedSearchQuery,
    setSearchQuery,
    selectedFilter,
    setSelectedFilter: handleFilterChange,
    paginationModel,
    setPaginationModel,
  }
}
